import { Link, useParams } from 'react-router-dom';
import cls from './PublicClientProject.module.scss';
import logo from './Logo.svg';
import moment from 'moment';
import { useQuery } from '@apollo/client';
import { QUERY_PUBLIC_CLIENT_PROJECT } from '../../../graphql/client';
import { Button, ConfigProvider, Progress, theme } from 'antd';
import React from 'react';
import ImageUrl from '../../../helpers/ImageUrl';
import _ from 'lodash';
import {
    to_public_client_project,
} from '../../../routes';
import { CheckOutlined, LeftOutlined } from '@ant-design/icons';
import slugify from 'slugify';

function pluralizePoints(number) {
    const absNumber = Math.abs(number) % 100;
    const lastDigit = absNumber % 10;

    // Исключения: 11-14 баллов
    if (absNumber > 10 && absNumber < 20) {
        return `${number} баллов`;
    }

    // Для 2, 3, 4 -> балла (кроме 12, 13, 14)
    if (lastDigit > 1 && lastDigit < 5) {
        return `${number} балла`;
    }

    // Для 1 -> балл (кроме 11)
    if (lastDigit === 1) {
        return `${number} балл`;
    }

    // Все остальные случаи (0, 5-9) -> баллов
    return `${number} баллов`;
}

export function PublicClientProjectGroup() {
    const { public_key, group } = useParams();

    const [good, setGood] = React.useState('Хорошо');

    const query = useQuery(QUERY_PUBLIC_CLIENT_PROJECT, {
        variables: {
            public_key: public_key,
            messages_sort: ['createdAt:DESC'],
            messages_pagination: {
                limit: 1,
            },
        },
    });

    if (query.error?.message === 'Not found') {
        return (
            <div className={cls.body}>
                <div className={cls.wrapper}>
                    <div className={cls.block}>
                        <h3>Страница не найдена</h3>
                        <span>Возможно ошибка в ссылке</span>
                        <span>Обратитесь за помощью к администратору</span>
                        <Button size={'large'} onClick={() => setGood('😊️️')}>
                            {good}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    const currentGroup = _.find(
        query.data?.publicClientProject.project?.experiences,
        (item) => slugify(item.name, { lower: true }) === group,
    );
    console.log('currentGroup', currentGroup);

    const mass = _.reduce(
        query.data?.publicClientProject?.project?.experiences,
        (sum, item) => {
            // Проверяем, что list существует и это строка
            if (typeof item.list === 'string' && item.list.trim() !== '') {
                // Разделяем по \n и прибавляем количество получившихся элементов
                return sum + item.list.split('\n').length;
            }
            return sum;
        },
        0,
    );

    const color = query.data?.publicClientProject?.project?.color || '#2D68C4';

    const list = currentGroup?.list?.trim().split('\n') || []
    const value = _.reduce(
        query.data?.publicClientProject?.projectData,
        (sum, item) => {
            // если этот навык есть у пользователя, добавляем 1 балл
            if (list.includes(item)) {
                return sum + 1;
            }
            return sum;
        },
        0,
    );
    const percent = value / list.length * 100;


    return (
        <div
            className={cls.body}
            style={{
                backgroundColor: color,
                backgroundImage: `url(${ImageUrl(query.data?.publicClientProject?.project?.cover?.url)})`,
            }}
        >
            <ConfigProvider
                theme={{
                    algorithm: theme.defaultAlgorithm,
                    token: {
                        colorPrimary: color,
                        colorLink: color,
                    },
                }}
            >
                <div className={cls.wrapper}>
                    <div className={cls.header}>
                        {query.data?.publicClientProject?.project?.logo && (
                            <img
                                className={cls.logo}
                                src={ImageUrl(query.data?.publicClientProject?.project?.logo?.url)}
                                alt={query.data?.publicClientProject?.project?.name}
                            />
                        )}
                        <img src={logo} className={cls.logo} alt={'Logo Sila Skilla'} />
                    </div>

                    <Link to={to_public_client_project(public_key)} className={cls.title}>
                        <Button type={'link'} icon={<LeftOutlined />} />
                        <h3>{currentGroup?.name}</h3>
                    </Link>

                    <div className={cls.block}>
                        <h3><b>{pluralizePoints(value)}</b> из {list.length}</h3>
                        <Progress percent={percent} showInfo={false} strokeColor={color} />
                    </div>

                    {currentGroup.description && (
                        <div className={cls.block}>
                            {currentGroup.description}
                        </div>
                    )}

                    <div className={cls.grid}>
                        {_.map(list, (item, index) => {
                            return (
                                <div key={`item${index}`} className={cls.block}>
                                    <div className={cls.header}>
                                        <span>{item}</span>
                                        {query.data?.publicClientProject?.projectData?.includes(item) && <CheckOutlined style={{ color: color }} />}
                                    </div>

                                </div>
                            );
                        })}
                    </div>

                    <div className={cls.divider} />

                    <div className={cls.footer}>
                        {_.map(query.data?.publicClientProject?.project?.links, (link, index) => (
                            <a key={`link${index}`} href={link.url} target={'_blank'} rel="noreferrer">
                                {link.name}
                            </a>
                        ))}
                        <span>© {moment().year()}</span>
                    </div>
                </div>
            </ConfigProvider>
        </div>
    );
}
